// src/components/Prompt.js
import React, { useState, useEffect } from 'react';
import Modal from './Modal';

export default function Prompt({ open, title='Edit', label='Value', initial='', onCancel, onOk, type='text' }) {
  const [v, setV] = useState(initial);
  useEffect(()=>setV(initial),[initial,open]);
  if (!open) return null;
  return (
    <Modal title={title} onClose={onCancel} className="max-w-md">
      <label className="block text-sm mb-1">{label}</label>
      <input
        type={type}
        value={v}
        onChange={e=>setV(e.target.value)}
        className="w-full bg-[#1a2230] border border-white/10 rounded px-3 py-2 mb-4"
      />
      <div className="flex justify-end gap-2">
        <button onClick={onCancel} className="px-4 py-2 rounded bg-slate-700 hover:bg-slate-600">Cancel</button>
        <button onClick={()=>onOk(v)} className="px-4 py-2 rounded bg-cyan-600 hover:bg-cyan-500">Save</button>
      </div>
    </Modal>
  );
}
